import { getMarketplace } from '@/marketplace'
import { isActivityFeedAvailable } from '@/territory'

export async function loadIsActivityFeedAvailable(): Promise<boolean> {
    return isActivityFeedAvailable((await getMarketplace()).musicTerritory)
}
